// Core
import React from "react";

// Styles
import "./styles.scss";

const Checkbox = ({ label, checked, shape = "square", onChange, style }) => {
  return (
    <div className={`checkbox ${shape}`}>
      <label>
      <input type="checkbox" checked={checked} onChange={onChange} style={style}/>
      {label}
      </label>
    </div>
  );
};

export default Checkbox;
